import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getConsolidationSummary(year?: number): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const params: Record<string, any> = {};
  if (year) {
    params.year = year;
  }
  const { data } = await api.get<ConsolidationSummaryType>('/consolidacao/get_page_data/', { params });
  return data;
}

type QueryFnType = typeof getConsolidationSummary;

function useConsolidationSummary(year?: number) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-summary', year],
    queryFn: () => getConsolidationSummary(year),
  });
}

export { getConsolidationSummary, useConsolidationSummary };
